import { Dispatch, SetStateAction } from "react";

type PStyleSettingArg = {
	setShowPalette: Dispatch<SetStateAction<boolean>>;
	setShowPartMove: Dispatch<SetStateAction<boolean>>;
};

export default function useStyleSetting(arg: PStyleSettingArg) {
	const { setShowPalette, setShowPartMove } = arg;

	const onShowMove = () => {
		setShowPalette(false);
	};
	const onShowPalette = () => {
		setShowPartMove(false);
	};
	return {
		onShowMove,
		onShowPalette,
	};
}
